import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { COMMERCE_PAYMENT_TYPE_ID, MEETING_EVENT_TYPE_ID, PAYMENT_LINK_TYPE_ID, CAMPAIGN_TYPE_ID, CUSTOMER_SUCCESS_ALERT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ViewXObjectsLink from './ViewXObjectsLink';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useAssociatedObjectsCardContentContext } from '../context/AssociatedObjectsCardContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getObjectTypesWithoutIndexPage = hasScope => {
  return [MEETING_EVENT_TYPE_ID, PAYMENT_LINK_TYPE_ID, CAMPAIGN_TYPE_ID, CUSTOMER_SUCCESS_ALERT_TYPE_ID, '0-144', !hasScope('commerce-payments-access') && COMMERCE_PAYMENT_TYPE_ID].filter(Boolean);
};
const AssociatedObjectsCardPaginator = ({
  onViewMore
}) => {
  var _associationsData$imp, _associationsData$imp2;
  const {
    associationsData,
    hasScope,
    toObjectTypeId,
    associationTypesData
  } = useAssociatedObjectsCardContentContext();
  const {
    associationTypes
  } = associationTypesData;
  const objectTypeHasIndexPage = !getObjectTypesWithoutIndexPage(hasScope).includes(toObjectTypeId);
  const isViewXCompatible = objectTypeHasIndexPage;
  const areAssociationTypesLoaded = associationTypes.length > 0;
  const shouldShowViewXObjectsLink = isViewXCompatible && areAssociationTypesLoaded;
  const hasMore = (_associationsData$imp = (_associationsData$imp2 = associationsData.impliedUnlabeledAssociationObjects) === null || _associationsData$imp2 === void 0 ? void 0 : _associationsData$imp2.hasMore) !== null && _associationsData$imp !== void 0 ? _associationsData$imp : false;

  /**
   * Removing the wrapping div will cause a regression where the UIButton is truncated.
   * This div prevents the UIButton from being an immediate child of the containing flex box.
   * See https://css-tricks.com/flexbox-truncated-text/
   **/
  const viewMoreButton = hasMore && /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Button, {
      "data-selenium-test": "associated-objects-card-view-more",
      "data-test-id": "associated-objects-card-view-more",
      onClick: onViewMore,
      size: 'xs',
      use: "tertiary-light",
      marginInlineEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.AssociatedObjectsCardPaginator.viewMore"
      })
    })
  });
  return /*#__PURE__*/_jsxs(TFlex, {
    children: [viewMoreButton, shouldShowViewXObjectsLink ? /*#__PURE__*/_jsx(ViewXObjectsLink, {}) : null]
  });
};
AssociatedObjectsCardPaginator.propTypes = {
  onViewMore: PropTypes.func.isRequired
};
export default AssociatedObjectsCardPaginator;